type projectKeys = "stage" | "ezpin" | "sigma";

type projectConfig = {
  [key in projectKeys]: projectProps;
};

interface projectProps {
  title: string;
  email: string;
  webUrl: string;
  registerUrl: string;
  videoUrl: string;
  freshdeskUrl: string;
  keyword: string;
  imageAlt: string;
  logoSrc: string;
  logoPlaceHolderSrc: string
  faviconSrc: string
  logoPrintSrc: string
  authTitle: string
}

export const props: projectConfig = {
  stage: {
    title: "EZPin Stage",
    email: "info@ezpin.ae",
    webUrl: "www.ezpin.ae",
    registerUrl: "https://register-stage.ezpin.ae/",
    videoUrl:
      "https://youtube.com/playlist?list=PLZOnMXDVB2iMnz4ngCf0yHVVlMTcB5YT4",
    freshdeskUrl: "https://ezpin-stage.freshdesk.com",
    keyword: "ezpin-stage-r",
    imageAlt: "ezpin-stage",
    logoSrc: "/assets/images/e-logo.png",
    logoPlaceHolderSrc: "/assets/images/logo-place.jpg",
    faviconSrc: "/assets/images/favicon.png",
    logoPrintSrc: "/assets/images/logo-print_2.png",
    authTitle: 'EZPin Stage'
  },

  ezpin: {
    title: "EZPIN",
    email: "info@ezpin.com",
    webUrl: "www.ezpin.com",
    registerUrl: "https://register.ezpin.com/",
    videoUrl: "https://www.youtube.com/@ezpin1450/videos",
    freshdeskUrl: "https://ezpin.freshdesk.com",
    keyword: "ezpin-r",
    imageAlt: "ezpin",
    logoSrc: "/assets/images/e-logo.png",
    logoPlaceHolderSrc: "/assets/images/logo-place.jpg",
    faviconSrc: "/assets/images/favicon.png",
    logoPrintSrc: "/assets/images/logo-print_2.png",
    authTitle: 'EZ Pin'
  },

    sigma: {
    title: "Sigma",
    email: "info@ezpin.com",
    webUrl: "www.ezpin.com",
    registerUrl: "https://register.ezpin.com/",
    videoUrl: "https://www.youtube.com/@ezpin1450/videos",
    freshdeskUrl: "https://ezpin.freshdesk.com",
    keyword: "ezpin-r",
    imageAlt: "ezpin",
    logoSrc: "/assets/images/sigma-logo.png",
    logoPlaceHolderSrc: "/assets/images/sigma-place.png",
    faviconSrc: "/assets/images/sigma-favicon.png",
    logoPrintSrc: "/assets/images/logo-print.png",
    authTitle: 'Sigma'
  },
};
